import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-committees',
    templateUrl: './committees.component.html',
    styleUrls: ['./committees.component.scss']
})
export class CommitteesComponent implements OnInit {

    constructor(private meta: Meta,
                private titles: Title) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI’s All Committees: Strengthening Governance');
        this.meta.updateTag({
            name: 'description',
            content: `Discover ARNI’s All Committees, fostering collaborative decision-making and robust governance to achieve institutional excellence and integrity.`
        });
    }

}
